module.exports = __webpack_public_path__ + "media/images/svg/arrow_down-e84382516c52ce3e83f660e411d4e0b1.svg";